<template>
  <div id="password-reset-confirm-view">
    <div class="form-content md-layout md-alignment-center-center">
      <md-card class="md-layout-item md-size-50 md-small-size-100 md-elevation-5">
        <md-card-header>
          <div class="md-title">Réinitialiser le mot de passe</div>
        </md-card-header>
        <md-card-content>
          <template v-if="resetLoading">
            chargement...
          </template>
          <template v-else-if="!resetCompleted">
            <form @submit.prevent="submit">
              <md-field>
                <label for="password1">Mot de passe</label>
                <md-input
                  v-model="inputs.password1"
                  type="password"
                  id="password1"
                  required />
              </md-field>
              <md-field>
                <label for="password2">Confirmation du mot de passe</label>
                <md-input
                  v-model="inputs.password2"
                  type="password"
                  id="password2"
                  required />
              </md-field>
            </form>
            <div class="actions">
              <md-button
                @click="resetPassword(inputs)"
                class="md-primary md-raised">
                Réinitialiser le mot de passe
              </md-button>
            </div>
            <span
              class="error"
              v-show="resetError">
              Une erreur s'est produite lors du traitement de votre demande.
            </span>
          </template>
          <template v-else>
            Votre mot de passe a été réinitialisé.
            <router-link to="/login">retourner à la page de connexion</router-link>
          </template>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      inputs: {
        password1: '',
        password2: '',
        uid: this.$route.params.uid,
        token: this.$route.params.token
      }
    }
  },
  created () {
    var app = this
    app.$store.dispatch('routing/update_title', 'Mot de passe réinitialisé')
    app.$store.dispatch('routing/update_return_kwargs', null)
  },
  computed: mapState('password', [
    'resetCompleted',
    'resetError',
    'resetLoading'
  ]),
  methods: mapActions('password', [
    'resetPassword',
    'clearResetStatus'
  ])
}
</script>

<style>
.form-content {
  padding-top: 5vh;
  .md-card-header {
    border-bottom: 1px solid #eee;
    margin-top: 2px;
  }
  .md-card-content {
    padding-top: 20px;
  }
  .md-primary {
    color: white !important;
  }
  .actions {
    padding: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #eee;
    background: #f5f5f5;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PasswordResetConfirm.vue